// extracted by mini-css-extract-plugin
export default {"customWidth":"ContextMenuLicenceTable_customWidth__vQKIi"};